import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import axios from "axios";
import { Button, Message, Table } from "semantic-ui-react";
import { getAuthHttpHeaders } from "../auth";
import CurrencyPair from "../components/CurrencyPair";
import { formatCrypto, formatPercent } from "../utils/numberFormat";
import { formatShortDateTimeFromApi, instantFromApi } from "../utils/dateTime";
import { ChronoUnit, Instant } from "js-joda";
import { avatar } from "../utils/avatar";

@inject("store")
@observer
class Trades extends Component {
  state = {
    limit: 100,
    trades: null,
  };

  componentDidMount() {
    this.load();
    this.refreshTimer = setInterval(() => {
      this.load();
    }, 60 * 1000);
  }

  componentWillUnmount() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
    }
  }

  load = async () => {
    const { limit } = this.state;

    this.setState({ loading: true, error: false });

    try {
      let axiosRequest = axios.create({
        baseURL: "api",
        headers: {
          Accept: "application/json",
          ...getAuthHttpHeaders(),
        },
        params: {
          limit,
        },
      });

      let response = await axiosRequest.get("trade/closed");
      this.setState({ trades: response.data });
    } catch (error) {
      console.error(error);
      this.setState({ error, trades: undefined });
    } finally {
      this.setState({ loading: false });
    }
  };

  isRecent = apiValue => {
    return apiValue && instantFromApi(apiValue).isAfter(Instant.now().minus(1, ChronoUnit.HOURS));
  };

  render() {
    const { trades, loading, error } = this.state;
    const {
      store: { zoneId },
    } = this.props;

    const buttons = (
      <Button.Group>
        <Button content="Refresh" icon="refresh" onClick={this.load} loading={loading} />
      </Button.Group>
    );

    return (
      <div>
        <br />
        {buttons}
        {error && <Message negative>Error reading data: {error.message}</Message>}
        {trades && (
          <Table celled unstackable collapsing style={{ whiteSpace: "nowrap", textAlign: "center" }}>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Exchange</Table.HeaderCell>
                <Table.HeaderCell>
                  Currency<br />Pair
                </Table.HeaderCell>
                <Table.HeaderCell>
                  Profit<br />%
                </Table.HeaderCell>
                <Table.HeaderCell>Close Time</Table.HeaderCell>
                <Table.HeaderCell>Open Time</Table.HeaderCell>
                <Table.HeaderCell>Bot</Table.HeaderCell>
                <Table.HeaderCell>Open Total</Table.HeaderCell>
                <Table.HeaderCell>Profit</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {trades.map(t => {
                const currencyPair = t.base + "/" + t.counter;
                const botAvatar = avatar(t.botId, 16, { verticalAlign: "middle", marginRight: "3px" });
                return (
                  <Table.Row key={t.id}>
                    <Table.Cell style={{ textTransform: "capitalize" }}>{t.exchangeType.toLowerCase()}</Table.Cell>
                    <Table.Cell>
                      <CurrencyPair exchangeType={t.exchangeType} currencyPair={currencyPair} />
                    </Table.Cell>
                    <Table.Cell positive={t.profitTotal > 0} negative={t.profitTotal < 0}>
                      {t.profitTotal && formatPercent(t.profitTotal / t.openTotal)}
                    </Table.Cell>
                    <Table.Cell warning={this.isRecent(t.closeDate)}>
                      {formatShortDateTimeFromApi(t.closeDate, zoneId)}
                    </Table.Cell>
                    <Table.Cell warning={this.isRecent(t.openDate)}>
                      {formatShortDateTimeFromApi(t.openDate, zoneId)}
                    </Table.Cell>
                    <Table.Cell>
                      {botAvatar}
                      {t.botId.substring(0, 4)}
                    </Table.Cell>
                    <Table.Cell>{formatCrypto(t.openTotal)}</Table.Cell>
                    <Table.Cell positive={t.profitTotal > 0} negative={t.profitTotal < 0}>
                      {t.profitTotal && formatCrypto(t.profitTotal)} {t.counter}
                    </Table.Cell>
                  </Table.Row>
                );
              })}
            </Table.Body>
          </Table>
        )}
        {trades && buttons}
      </div>
    );
  }
}

export default Trades;



// WEBPACK FOOTER //
// ./src/trade/Trades.js